module.exports = __webpack_public_path__ + "img/icons/apple-black-9b56ee2f42e5df5622ccc847c09c24c2.svg";